import dayjs from "dayjs";
/* 今天 */
export const today = {
  text: "今天",
  symbol: "today",
  date: [dayjs(), dayjs()],
};
/* 昨天 */
export const yesterday = {
  text: "昨天",
  symbol: "yesterday",
  date: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
};
/* 近七天 */
export const nearly7 = {
  text: "近7天",
  symbol: "nearly7",
  date: [dayjs().subtract(7, "day"), dayjs()],
};
/** 近30天 */
export const nearly30 = {
  text: "近30天",
  symbol: "nearly30",
  date: [dayjs().subtract(30, "day"), dayjs()],
};
/** 本月至今 */
export const thisMonthToday = {
  text: "本月",
  symbol: "thisMonthToday",
  date: [dayjs().startOf("month"), dayjs()],
};
/** 本月 */
export const thisMonth = {
  text: "本月",
  symbol: "thisMonth",
  date: [dayjs().startOf("month"), dayjs().endOf("month")],
};
/** 上月 */
export const lastMonth = {
  text: "上月",
  symbol: "lastMonth",
  date: [
    dayjs().add(-1, "month").startOf("month"),
    dayjs().add(-1, "month").endOf("month"),
  ],
};
/* 本年至今 */
export const thisYearToday = {
  text: "本年至今",
  symbol: "thisYearToday",
  date: [dayjs().startOf("year"), dayjs()],
};
/** 完整的日期快捷配置 */
export const dateConfig = {
  today,
  yesterday,
  nearly7,
  nearly30,
  thisMonthToday,
  thisMonth,
  lastMonth,
  thisYearToday,
};
export const defaultShortType = [
  "today",
  "yesterday",
  "nearly7",
  "thisMonthToday",
  "thisMonth",
  "lastMonth",
  "thisYearToday",
];

export interface shortcutsItem {
  text: string;
  value: Date[];
}
/* 获取快捷配置 */
export const getShortcuts = (config: string[]): shortcutsItem[] => {
  return config.map((v) => {
    return {
      text: dateConfig[v].text,
      value: dateConfig[v].date,
    };
  });
};
